export const environment = {
  production: false
};

export const BASE_URL_SERVER = 'https://dev.hellositter.com/hscs'
export const ENVIRONMENT_NAME = 'DEVELOPMENT'
